import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Footer = () => (
  <footer className="text-white pt-5 pb-1 mb-0" style={{ backgroundColor: '#070a11', borderTop: '3px solid #d4a43a', marginBottom: 0 }}>
    <div className="container">
      <div className="row text-center text-md-start">
        {/* About */}
        <div className="col-12 col-md-4 mb-4">
          <h5 className="text-uppercase mb-3 arcane-gold" style={{ borderBottom: '2px solid #d4a43a', display: 'inline-block', letterSpacing: '2px' }}>
            CORSIT
          </h5>
          <p className="small" style={{ fontFamily: "'Alphakind', sans-serif" }}>
            Corsit is the Robotics Club of Siddaganga Institute of Technology. Established in 2006, works under the
            patronage of e-Yantra cell of IIT Bombay.
          </p>
          <div
            className="d-flex gap-3 justify-content-center justify-content-md-start mt-3 fs-5"
            style={{ fontFamily: "'Alphakind', sans-serif" }}
          >
            <a href="https://youtube.com/@corsit547?si=SIP6pSunFoCz-HVo" style={{ color: '#d4a43a' }}>
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://www.instagram.com/corsit.sit/" style={{ color: '#d4a43a' }}>
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.linkedin.com/company/corsit" style={{ color: '#d4a43a' }}>
              <i className="fab fa-linkedin-in"></i>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="col-12 col-md-4 mb-4">
          <h5 className="text-uppercase mb-3 arcane-gold" style={{ borderBottom: '2px solid #d4a43a', display: 'inline-block', letterSpacing: '2px' }}>
            Quick Links
          </h5>
          <ul className="list-unstyled" style={{ fontFamily: "'Alphakind', sans-serif" }}>
            <li>
              <a href="#home" className="text-white text-decoration-none">Home</a>
            </li>
            <li>
              <a href="#events" className="text-white text-decoration-none">Events</a>
            </li>
            <li>
              <a href="https://www.corsit.in" className="text-white text-decoration-none" target="_blank" rel="noreferrer">
                About
              </a>
            </li>
            <li>
              <a href="#contact" className="text-white text-decoration-none">Contact</a>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div className="col-12 col-md-4 mb-4">
          <h5 className="text-uppercase mb-3 arcane-gold" style={{ borderBottom: '2px solid #d4a43a', display: 'inline-block', letterSpacing: '2px' }}>
            Contact
          </h5>
          <ul className="list-unstyled small" style={{ fontFamily: "'Alphakind', sans-serif" }}>
            <li className="mb-2">
              <i className="fas fa-map-marker-alt me-2" style={{ color: '#d4a43a' }}></i>
              Siddaganga Institute of Technology, Tumkur, Karnataka
            </li>
             <li>
              <i className="fas fa-envelope me-2" style={{ color: '#d4a43a' }}></i>
              <a href="mailto:corsit@sit.ac.in" className="text-white text-decoration-none">corsit@sit.ac.in</a>
            </li>
            <li>
              <i className="fas fa-globe me-2" style={{ color: '#d4a43a' }}></i>
              <a href="https://www.corsit.in" className="text-white text-decoration-none" target="_blank" rel="noreferrer">
                www.corsit.in
              </a>
            </li>

            {/* WhatsApp Contacts */}
            <li className="mb-2">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <div style={{ fontFamily: "'Alphakind', sans-serif" }} className="gradient-text">Guru Srisha</div>
                </div>
                <a
                  href="https://wa.me/+917975215782"
                  target="_blank"
                  rel="noreferrer"
                  className="social-media-link w-inline-block"
                >
                  <i className="fab fa-whatsapp" style={{ color: '#d4a43a', fontSize: '1.5rem' }}></i>
                </a>
              </div>
            </li>
            

            <li className="mb-2">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <div style={{ fontFamily: "'Alphakind', sans-serif" }} className="gradient-text">Chaithra H R</div>
    
                </div>
                <a
                  href="https://wa.me/+918152875878"
                  target="_blank"
                  rel="noreferrer"
                  className="social-media-link w-inline-block"
                >
                  <i className="fab fa-whatsapp" style={{ color: '#d4a43a', fontSize: '1.5rem' }}></i>
                </a>
              </div>
            </li>

           
          </ul>
        </div>
      </div>
      <hr className="border-secondary" />
      <p className="text-center small mb-0" style={{ fontFamily: "'Alphakind', sans-serif" }}>
        &copy; 2026 Robocor. All rights reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
